import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Col,
  Row,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
  Modal,
} from "react-bootstrap";
import { getFormattedUser } from "../../services/auth";
import NotificationSystem from "react-notification-system";
import { style as notificationStyling } from "../../variables/Variables.jsx";
import { constants } from "../../redux/textBlasts/actions";
import { commonConstants } from "../../redux/common/actions";
import { formUtils } from "../../redux/textBlasts/utils";

const { checkFields } = formUtils();

const { REQUEST, FAILURE } = commonConstants;
const { UPDATE_BLAST_FORM_FIELD, SUBMIT_BLAST_FORM } = constants;

const UserForm = () => {
  const {
    loading,
    sending,
    error = {},
    success = {},
    ...form
  } = useSelector((state) => state.textBlasts);
  const dispatch = useDispatch();
  const notificationSystem = useRef();
  const [,] = useState(null);
  const [_notificationSystem, setNotificationSystem] = useState({});

  const { message } = form;

  const formattedPayload = form;

  // initial page fetch
  useEffect(() => {
    //dispatch({ type: GET_ALL_USERS + REQUEST })
    setNotificationSystem(notificationSystem);
    return () => {};
  }, []);

  // retrieve user
  const [hasHrAdmin, setHasHrAdmin] = useState(false);
  const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);

  useEffect(() => {
    const getUser = async () => {
      const user = await getFormattedUser();
      const hasHrAdmin = user && user.roles && user.roles.includes("HrAdmin");
      setHasHrAdmin(hasHrAdmin);
    };
    getUser().then();
  }, []);

  // handle ajax side effects
  useEffect(() => {
    const notificationSystem = _notificationSystem.current;
    if (notificationSystem && success.message) {
      notificationSystem.addNotification({
        message: success.message,
        level: "info",
        position: "tc",
      });
    }
    if (notificationSystem && error.message) {
      notificationSystem.addNotification({
        message: error.message,
        level: "error",
        position: "tc",
      });
    }
    return () => {};
  }, [success.message, error.message]);
  // handle scroll to top for notifications
  useEffect(() => {
    // THIS IS SCREWY - Desktop works fine, Mobile scrolls to top quickly then back to original position - 2x fixed this
    document.getElementById("top-of-the-form-to-ya").scrollIntoView(true);
    document.getElementById("top-of-the-form-to-ya").scrollIntoView(true);
    return () => {};
  }, [success.message, error.message]);

  const confirmSendMessage = () => {
    dispatch({ type: SUBMIT_BLAST_FORM + REQUEST, payload: formattedPayload });
    setConfirmModalIsOpen(false);
  };

  const handlePrepareTextBlast = () => {
    const validationErrors = checkFields(form);
    if (validationErrors.length > 0) {
      dispatch({
        type: SUBMIT_BLAST_FORM + FAILURE,
        payload: { message: validationErrors.join(" ") },
      });
      return;
    }
    setConfirmModalIsOpen(true);
  };

  return (
    <div className="main-content">
      <NotificationSystem
        ref={notificationSystem}
        style={notificationStyling}
      />
      <Form>
        <Grid fluid>
          <Row>
            <Col xs={12} sm={12}>
              <FormGroup>
                <ControlLabel>Message</ControlLabel>
                <FormControl
                  componentClass="textarea"
                  id="message"
                  name="message"
                  value={message}
                  style={{ height: "200px" }}
                  onChange={(event) => handleChange(dispatch, event)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12}>
              {hasHrAdmin && (
                <Button
                  style={{ marginRight: "15px" }}
                  bsStyle="primary"
                  bsSize="lg"
                  onClick={handlePrepareTextBlast}
                >
                  Prepare Text Blast
                </Button>
              )}
            </Col>
          </Row>
        </Grid>
      </Form>
      <Modal
        show={confirmModalIsOpen}
        onHide={() => {
          setConfirmModalIsOpen(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Text Blast</Modal.Title>
          <Modal.Body>
            <Row>
              <Col xs={12}>
                You are about to send the following message to all active Call
                Takers registered with CoplineHQ. Please confirm you would like
                to perform this action. There will be Twilio costs incurred.
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={12}>Message Being Sent:</Col>
              <Col xs={12}>{message}</Col>
            </Row>

            <Row style={{ marginTop: "20px" }}>
              <Col>
                <Button
                  bsStyle={"primary"}
                  fill="true"
                  block
                  onClick={() => {
                    confirmSendMessage();
                  }}
                  disabled={sending}
                >
                  Send Text Blast
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    </div>
  );
};

function handleChange(dispatch, event, formField) {
  let field = null;
  let value = null;
  if (
    ["initialTrainingClassDate"].includes(
      formField
    )
  ) {
    field = formField;
    value = event;
  } else if (event.target) {
    field = event.target.name;
    value = event.target.value;
    value = value === "true" ? true : value;
    value = value === "false" ? false : value;
  } else {
    // select form items
    field = formField;
    value = event;
  }

  // alert(`field ${field} and value ${value}`)
  return dispatch({ type: UPDATE_BLAST_FORM_FIELD, field, value });
}

export default UserForm;
